import React from 'react';

export default function Process() {
    return (
        <section id="processo" className="py-20 px-4 bg-white">
            <div className="max-w-5xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-black">
                    Como <span className="text-cyan-400">trabalhamos</span>
                </h2>
                <div className="space-y-6">
                    <div className="flex gap-6 items-start">
                        <div className="bg-cyan-400 text-black w-16 h-16 rounded-full flex items-center justify-center font-bold text-2xl flex-shrink-0">1</div>
                        <div>
                            <h3 className="text-2xl font-bold mb-2 text-black">Discovery & Planejamento</h3>
                            <p className="text-gray-700">Converso com você, entendo seus objetivos, desafios e visão do projeto. Definimos escopo, tecnologias e cronograma claro.</p>
                        </div>
                    </div>
                    <div className="flex gap-6 items-start">
                        <div className="bg-green-500 text-white w-16 h-16 rounded-full flex items-center justify-center font-bold text-2xl flex-shrink-0">2</div>
                        <div>
                            <h3 className="text-2xl font-bold mb-2 text-black">Desenvolvimento</h3>
                            <p className="text-gray-700">Uso metodologia ágil com entregas incrementais. Você acompanha o progresso e podemos fazer ajustes conforme necessário.</p>
                        </div>
                    </div>
                    <div className="flex gap-6 items-start">
                        <div className="bg-purple-500 text-white w-16 h-16 rounded-full flex items-center justify-center font-bold text-2xl flex-shrink-0">3</div>
                        <div>
                            <h3 className="text-2xl font-bold mb-2 text-black">Testes & Lançamento</h3>
                            <p className="text-gray-700">Testamos tudo para garantir qualidade. Depois, lançamos seu projeto e oferecemos suporte técnico completo.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
